export class LookupEntry {
    to;
    from;
    readonly element;

    constructor(element: HTMLElement, from: Number, to: Number) {
        this.to = to;
        this.from = from;
        this.element = element;
    }
}
